export default __webpack_public_path__ + "static/media/img_3.6a3d0c9c.jpg";